import { render } from "./RiFreeWait.vue?vue&type=template&id=740fc64e"
import script from "./RiFreeWait.vue?vue&type=script&lang=js"
export * from "./RiFreeWait.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiFreeWait.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "740fc64e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('740fc64e', __exports__)) {
    api.reload('740fc64e', __exports__)
  }
  
  module.hot.accept("./RiFreeWait.vue?vue&type=template&id=740fc64e", () => {
    api.rerender('740fc64e', render)
  })

}


export default __exports__